<template>
  <div class="age-slider">
    <div ref="slider"></div>
  </div>
</template>

<script>
import noUiSlider from 'nouislider'
import 'nouislider/dist/nouislider.css'

export default {
  name: 'AgeSlider',
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      slider: null,
      ageOptions: ['18', '25', '35', '45', '55', '65', '65+'],
      internalValue: []
    }
  },
  mounted () {
    const toIndex = val => this.ageOptions.indexOf(String(val))
    const startIndexes = this.value.map(toIndex)

    this.internalValue = [...this.value]

    this.slider = noUiSlider.create(this.$refs.slider, {
      start: startIndexes,
      connect: true,
      step: 1,
      range: {
        min: 0,
        max: this.ageOptions.length - 1
      },
      format: {
        to: v => v,
        from: v => Number(v)
      },
      pips: {
        mode: 'steps',
        density: 25,
        format: {
          to: value => this.ageOptions[Math.round(value)]
        }
      }
    })

    this.slider.on('update', values => {
      const selected = values.map(v => this.ageOptions[Math.round(v)])
      if (JSON.stringify(selected) !== JSON.stringify(this.internalValue)) {
        this.internalValue = [...selected]
        this.$emit('input', selected)
      }
    })
  },
  watch: {
    value (newVal) {
      if (!this.slider) return

      if (JSON.stringify(newVal) !== JSON.stringify(this.internalValue)) {
        const toIndex = val => this.ageOptions.indexOf(String(val))
        const newIndexes = newVal.map(toIndex)
        this.slider.set(newIndexes)
        this.internalValue = [...newVal]
      }
    }
  },
  beforeDestroy () {
    if (this.slider) {
      this.slider.destroy()
    }
  }
}
</script>

<style scoped>
.noUi-value {
  font-size: 0.8rem;
}
.age-slider >>> .noUi-connect {
  background: #d8ab44 !important;
}
</style>
